import primaryButton from '../../../../primary-button';

const light = (params) => primaryButton.solidIcon.background.hover.light(params);

export default light;
